import angular from "angular";
import { PaperCardComponent } from "./paperCard/paperCard.component";
import { SchemaEditorComponent } from "./schemaEditor/SchemaEditor.component";
import { PropertySchemaEditorComponent } from "./propertySchemaEditor/propertySchemaEditor.component";
import { SchemaNodeEditorComponent } from "./propertySchemaEditor/SchemaNodeEditor/SchemaNodeEditor.component";
import { EmptyPropertiesComponent } from "./propertySchemaEditor/EmptyPropertiesComponent/EmptyPropertiesComponent.component";
import { HistoryVariableSidebar } from "./historyVariableSidebar/historyVariableSidebar.component";
import { HistoryConfigSidebar } from "./historyConfigSidebar/historyConfigSidebar.component";
import { FixedFooterComponent } from "./FixedFooter/FixedFooter.component";
export const aiAgentCommonComponents = angular
    .module('aiAgentCommonComponents', [])
    .component('paperCard', PaperCardComponent)
    .component('schemaEditor', SchemaEditorComponent)
    .component('propertySchemaEditor', PropertySchemaEditorComponent)
    .component('schemaNodeEditor', SchemaNodeEditorComponent)
    .component('emptyProperties', EmptyPropertiesComponent)
    .component('historyVariableSidebar', HistoryVariableSidebar)
    .component('historyConfigSidebar', HistoryConfigSidebar)
    .component('fixedFooter', FixedFooterComponent)
    .name;
